import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { ToasterMsgService } from './toaster-msg.service';
import { Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-toaster-msg',
  templateUrl: './toaster-msg.component.html',
  styleUrls: ['./toaster-msg.component.scss']
})
export class ToasterMsgComponent {
  _config: any = {}
  constructor(private toasterService: ToasterMsgService,
    private router: Router,
  ) {
    this.toasterService.getToasterConfig().subscribe((res: any) => {
      if (res != null) {
        console.log(res);
        this._config = res;
        if (this._config?.showToaster) {
          $("#toaster-msg-popup").modal('show');
        }
      }
    })
  }


  resetToaster(){
    this.toasterService.setToasterConfig({
      iconType:'',
      showToaster:false,
      showIcon:false,
      localizeMsg:false,
      msg:''
    })
  }
}